import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSetRecoilState } from "recoil";
import { BoardInfoState_CommentRegKey, DialogMessageState, ImgViewer, ToastMessageState } from "../../recoil/states";
import { asyncReqCommunityReplyList, CommunityReplyListActions } from "../../reducers/CommunityReplyListReducer";
import { AppDispatch, RootState } from "../../Store";
import CommonUtil from "../../utils/CommonUtil";
import { CommunityReplyRegActions } from "../../reducers/CommunityReplyRegReducer";
import { asyncReqCommunityReplyRemove, CommunityReplyRemoveActions } from "../../reducers/CommunityReplyRemoveReducer";
import { Paper } from "@mui/material";
import { asyncReqIsLogin } from "../../reducers/LoginBtnsReducer";
import ReplyReg from "./ReplyReg";

const ReplyList = () => {

    const CommunityReplyListReducer_Result = useSelector((state: RootState) => state.CommunityReplyListReducer); // 댓글 표시 처리를 위한 state
    const CommunityReplyRegReducer_Result = useSelector((state: RootState) => state.CommunityReplyRegReducer); // 댓글 등록 처리를 위한 state
    const CommunityReplyRemoveReducer_Result = useSelector((state: RootState) => state.CommunityReplyRemoveReducer); // 댓글 삭제 처리를 위한 state
    const { MEM_UDID } = useSelector((state: RootState) => state.LoginBtnsReducer.asyncIsLogin); // '로그인 / 로그아웃' 버튼 표시 처리를 위한 state
    const setDialogMessageState = useSetRecoilState(DialogMessageState); // 다일얼로그 메세지 요청 정보를 갖는 state
    const setToastMessageState = useSetRecoilState(ToastMessageState); // 토스트 메세지 요청 정보를 갖는 state
    const setBoardInfoState_CommentRegKey = useSetRecoilState(BoardInfoState_CommentRegKey); // 댓글등록 UI 랜더링 처리를 위해 사용되는 state
    const setImgViewer = useSetRecoilState(ImgViewer); // 이미지 뷰어 UI 랜더링 처리를 위해 사용되는 state
    const dispatch = useDispatch<AppDispatch>();

    const [isMoreBtn, setIsMoreBtn] = useState(false); // 더보기 버튼 표시 여부
    const [answerTargetSeq, setAnswerTargetSeq] = useState(""); // '답글등록' 클릭 대상 댓글 고유번호를 가지는 state

    // 댓글 등록 or 삭제 후, 할당 받은 댓글 관련 데이터 (해당 댓글 위치로 자동 스크롤바 이동시켜주기 위한 용도)
    const regCommentData = useRef({
        comment_seq: '', // 댓글 고유번호
        prev_top: -1 // 댓글 삭제 후, 저장된 이전 스크롤바 top 값
    });

    /**
    * 특정 Element 가 현재 스크롤 위치에 보여지고 있는지 여부 판단
    * 
    * @param jqObj 이벤트 객체
    * @returns 표시 여부 (true / false)
    */
    const isInViewport = (jqObj: JQuery<HTMLElement>) => {
        var elementTop = jqObj.offset()?.top as number;
        var elementBottom = elementTop + (jqObj.outerHeight() as number);
        var viewportTop = $(window).scrollTop() as number;
        var viewportBottom = viewportTop + ($(window).height() as number);
        return elementBottom > viewportTop && elementTop < viewportBottom;
    }

    useEffect(() => {

        if (CommunityReplyListReducer_Result.status === "LOADING") {
            // 댓글 목록 > 통신 중 일 경우
        }
        else if (CommunityReplyListReducer_Result.status === "COMPLETE") {
            // 댓글 목록 > 통신 성공된 경우

            if (CommunityReplyListReducer_Result.n4ErrorCode !== 0) {
                // 에러가 발생한 경우

                const message = CommunityReplyListReducer_Result.strErrorMessage;
                setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: false, message }));
            }
            else {
                // 정상인 경우

                if (CommunityReplyListReducer_Result.currPage < CommunityReplyListReducer_Result.n4TotalPage) {
                    // 마지막 페이지가 아닐 경우
                    setIsMoreBtn(true); // '더보기' 버튼 표시
                }
                else {
                    // 마지막 페이지일 경우
                    setIsMoreBtn(false); // '더보기' 버튼 숨김
                }

                if (CommunityReplyListReducer_Result.LIST.length === 0) {
                    setIsMoreBtn(false); // '더보기' 버튼 숨김
                }

                if (regCommentData.current.comment_seq !== "" || regCommentData.current.prev_top !== -1) {
                    // 댓글 등록 or 삭제가 처리된 경우

                    const interval_move_to_comment_root = setInterval(() => {
                        if ($("#p_reply_loading > img[src=/images/ajax-loader-2.gif]").length > 0) return;
                        clearInterval(interval_move_to_comment_root);

                        if (regCommentData.current.comment_seq !== "") {
                            // 댓글 등록이 처리된 경우
                            const comment_root = $("#comment_root_" + regCommentData.current.comment_seq);
                            setTimeout(() => {
                                if (comment_root.length === 0) {
                                    CommonUtil.scrollTo("#navCommentListRoot", -7, 500); // 댓글이 다른 페이지에 존재할 경우, 댓글목록 최상단으로 스크롤바 자동 이동
                                }
                                else {
                                    CommonUtil.scrollTo(comment_root, -250, 500); // 해당 댓글 영역으로 스크롤바 자동 이동

                                    // 등록된 댓글 영역이 눈에 띄게 깜빡이는 하이라이트 효과 적용
                                    let loopHighlight = 4;
                                    const arrBackground = ["#ff8f54", comment_root.css("background")];
                                    const intvHighlightId = setInterval(() => {
                                        if (!isInViewport(comment_root)) return; // 특정 댓글 UI 영역이 현재 스크롤 위치에 보이는지 여부 판단
                                        if (loopHighlight <= 0) {
                                            clearInterval(intvHighlightId);
                                            return;
                                        }
                                        comment_root.css("background", arrBackground[loopHighlight % 2]);
                                        loopHighlight--;
                                    }, 300);
                                }
                            }, 100);
                            $("[id^=ipt_anonymous_]").attr("checked", "checked"); // 댓글 등록 UI에 체크했던 체크박스 초기화
                            $("[id^=txt_Reg_Comment_]").val(""); // 댓글 등록 UI에 입력했던 내용 삭제

                            // 댓글 등록 UI에 선택했던 파일 삭제
                            $("[id^=file_uploader_]").val("");

                            // 미리보기 이미지 초기화
                            $("[id^=preview_]").attr("src", "");
                            $('[id^=preview_root_]').hide();

                            $("[id^=root_emoji_]").hide(); // 이모지 영역 숨김

                            setAnswerTargetSeq(""); // 대댓글 등록 UI 숨김 처리
                        }
                        else if (regCommentData.current.prev_top !== -1) {
                            // 댓글 삭제가 처리된 경우

                            CommonUtil.scrollTo(regCommentData.current.prev_top, 0, 500); // 이전 top 영역으로 스크롤바 자동 이동
                        }

                        // 댓글 관련 데이터 초기화
                        regCommentData.current.comment_seq = ""; // 댓글 고유번호
                        regCommentData.current.prev_top = -1 // 댓글 삭제 후, 저장된 이전 스크롤바 top 값
                    }, 100);
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [CommunityReplyListReducer_Result]);

    useEffect(() => {

        if (CommunityReplyRegReducer_Result.status === "LOADING") {
            // 댓글 등록 > 통신 중 일 경우
        }
        else if (CommunityReplyRegReducer_Result.status === "FAIL") {
            // 댓글 등록 > 통신 실패된 경우

            const message = "댓글 등록 실패, 통신 처리 중 알 수 없는 오류가 발생하였습니다.";
            setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: false, message }));
        }
        else if (CommunityReplyRegReducer_Result.status === "COMPLETE") {
            // 댓글 등록 > 통신 성공된 경우

            // 댓글 등록 UI의 '별명' 입력란을 숨기기 위함
            dispatch(asyncReqIsLogin({ logout_req_yn: "N", show_dim: false })); // 로그인 여부 값 가져오기 (로딩바 표시되지 않도록 'show_dim' 값을 'false'로 세팅)

            dispatch(CommunityReplyRegActions.setInitStatus()); // 여기 영역이 중복 실행되지 않도록 초기화 실행

            if (CommunityReplyRegReducer_Result.n4ErrorCode !== 0) {

                const message = CommunityReplyRegReducer_Result.strErrorMessage;
                setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: false, message }));
            }
            else if (!CommunityReplyRegReducer_Result.isSuccess) {

                const message = "댓글 등록 처리 중 알 수 없는 오류가 발생하였습니다.";
                setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: false, message }));
            }
            else {

                const message = "댓글이 등록 되었습니다.";
                setToastMessageState(rawState => ({ ...rawState, isShow: true, message }));

                setBoardInfoState_CommentRegKey(Math.random().toString()); // 댓글등록 UI 리랜더링 요청
                dispatch(asyncReqIsLogin({ logout_req_yn: "N", show_dim: false })); // 로그인 여부 값 가져오기 (로딩바 표시되지 않도록 'show_dim' 값을 'false'로 세팅)

                // 댓글 관련 데이터 갱신
                regCommentData.current.comment_seq = CommunityReplyRegReducer_Result.INFO?.UCBC_COMMENT_SEQ || ""; // 댓글 고유번호

                // 신규 댓글 목록 배열에 추가
                dispatch(CommunityReplyListActions.addList({
                    V_NO: 0,
                    _id: "000000000000000000000000",
                    UCBC_COMMENT_SEQ: CommunityReplyRegReducer_Result.INFO?.UCBC_COMMENT_SEQ,
                    UCBC_BOARD_SEQ: CommunityReplyRegReducer_Result.INFO?.UCBC_BOARD_SEQ,
                    UCBC_REF_COMMENT_SEQ: CommunityReplyRegReducer_Result.INFO?.UCBC_REF_COMMENT_SEQ,
                    UCBC_CONTENT: CommunityReplyRegReducer_Result.INFO?.UCBC_CONTENT,
                    UCBC_IMG_PATH: CommunityReplyRegReducer_Result.INFO?.UCBC_IMG_PATH,
                    UCBC_REG_MEM_UDID: CommunityReplyRegReducer_Result.INFO?.UCBC_REG_MEM_UDID,
                    UCBC_REG_NICKNAME: CommunityReplyRegReducer_Result.INFO?.UCBC_REG_NICKNAME,
                    UCBC_ANONYMOUS_YN: CommunityReplyRegReducer_Result.INFO?.UCBC_ANONYMOUS_YN,
                    UCBC_DEL_YN: CommunityReplyRegReducer_Result.INFO?.UCBC_DEL_YN,
                    UCBC_DEL_DT: CommunityReplyRegReducer_Result.INFO?.UCBC_DEL_DT,
                    UCBC_REG_DT: CommunityReplyRegReducer_Result.INFO?.UCBC_REG_DT
                }));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [CommunityReplyRegReducer_Result]);

    useEffect(() => {

        if (CommunityReplyRemoveReducer_Result.status === "LOADING") {
            // 댓글 삭제 > 통신 중 일 경우
        }
        else if (CommunityReplyRemoveReducer_Result.status === "FAIL") {
            // 댓글 삭제 > 통신 실패된 경우

            const message = "댓글 삭제 실패, 통신 처리 중 알 수 없는 오류가 발생하였습니다.";
            setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: false, message }));
        }
        else if (CommunityReplyRemoveReducer_Result.status === "COMPLETE") {
            // 댓글 삭제 > 통신 성공된 경우

            dispatch(CommunityReplyRemoveActions.setInitStatus()); // 여기 영역이 중복 실행되지 않도록 초기화 실행

            if (CommunityReplyRemoveReducer_Result.n4ErrorCode !== 0) {

                const message = CommunityReplyRemoveReducer_Result.strErrorMessage;
                setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: false, message }));
            }
            else if (!CommunityReplyRemoveReducer_Result.isSuccess) {

                const message = "댓글 삭제 처리 중 알 수 없는 오류가 발생하였습니다.";
                setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: false, message }));
            }
            else {

                const message = "댓글이 삭제 되었습니다.";
                setToastMessageState(rawState => ({ ...rawState, isShow: true, message }));

                // 댓글 관련 데이터 갱신
                regCommentData.current.prev_top = window.scrollY; // 댓글 삭제 후, 저장된 이전 스크롤바 top 값

                // 삭제된 댓글 목록 배열에서 삭제
                dispatch(CommunityReplyListActions.removeItem(CommunityReplyRemoveReducer_Result.INFO?.UCBC_COMMENT_SEQ));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [CommunityReplyRemoveReducer_Result]);

    /**
    * 댓글삭제 버튼 클릭 이벤트 
    * 
    * @param {React.MouseEvent<HTMLAnchorElement, MouseEvent>} e 이벤트 객체
    * @param {string} comment_seq 댓글 고유번호
    * @returns {void}
    */
    const hendlerReplyDel = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, comment_seq: string): void => {
        e.preventDefault();

        dispatch(asyncReqCommunityReplyRemove({ comment_seq }));
    }

    /**
    * 답변등록 버튼 클릭 이벤트 
    * 
    * @param {React.MouseEvent<HTMLAnchorElement, MouseEvent>} e 이벤트 객체
    * @param {string} comment_seq 댓글 고유번호
    * @returns {void}
    */
    const hendlerAnswer = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, comment_seq: string): void => {
        e.preventDefault();

        if (MEM_UDID === "") {
            const message = "로그인 후 이용 가능합니다.";
            setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: false, message }));
            return;
        }
        if (comment_seq !== "") {
            $("#txt_Reg_Comment_" + comment_seq).val("");  // 댓글 등록 > 입력했던 내용 제거
            $("#root_emoji_" + comment_seq).hide(); // 이모지 영역 숨김
        }

        setAnswerTargetSeq(state => state = comment_seq);
    }

    /**
    * 더보기 버튼 클릭 이벤트 
    * 
    * @param {React.MouseEvent<HTMLAnchorElement, MouseEvent>} e 이벤트 객체
    * @returns {void}
    */
    const handlerAddBtn = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
        e.preventDefault();

        const page_size = parseInt(process.env.REACT_APP_COMMUNITY_REPLY_PAGE_SIZE as string, 10);
        const curr_page = CommunityReplyListReducer_Result.currPage + 1;
        const board_seq = CommonUtil.getQuerystring("board_seq", "");
        dispatch(asyncReqCommunityReplyList({ page_size, curr_page, board_seq }));
        dispatch(CommunityReplyListActions.setCurrPage(curr_page)); // 현재 페이지 번호 저장
    }

    if (
        (CommunityReplyListReducer_Result.status === "LOADING" || CommunityReplyListReducer_Result.status === "FAIL") &&
        CommunityReplyListReducer_Result.currPage === 1 // 첫번째 페이지 일 경우만 바닥 로딩바 표시
    ) {

        return (
            <p id="p_reply_loading" className="bo_vc_empty">
                <img src="/images/ajax-loader-2.gif" alt="" /><br /><br />댓글 목록을 가져오는 중입니다..
            </p>
        );
    }
    else {

        return <>
            <nav className="bo_cate" id="navCommentListRoot" style={{ width: "100%" }}>
                <ul className="bo_cate_ul">
                    <li>
                        <span className="cmt_btn">댓글목록</span>
                    </li>
                </ul>
            </nav>
            <section className="bo_vc">
                {
                    CommunityReplyListReducer_Result.MORE_LIST.length === 0 ?
                        <p id="p_reply_loading" className="bo_vc_empty">
                            등록된 댓글이 없습니다.
                        </p>
                        :
                        <>
                            {
                                CommunityReplyListReducer_Result.MORE_LIST?.map((item, idx) => {
                                    if (item.UCBC_COMMENT_SEQ === item.UCBC_REF_COMMENT_SEQ) {
                                        // 댓글 일 경우

                                        return (
                                            <div key={idx}>
                                                <article className="c_5241" key={idx} id={"comment_root_" + item.UCBC_COMMENT_SEQ}>
                                                    <div className="cmt_contents">
                                                        <div>
                                                            {
                                                                item.UCBC_ANONYMOUS_YN === "Y" ?
                                                                    <span className="guest anonymous" style={{ float: "left" }}>익명</span>
                                                                    :
                                                                    <span className="guest" style={{ float: "left" }}>{item.UCBC_REG_NICKNAME}</span>
                                                            }
                                                            <span className="bo_vc_hdinfo" style={{ float: "right", textAlign: "right" }}>
                                                                {
                                                                    item.UCBC_REG_MEM_UDID === MEM_UDID ? <>
                                                                        <a href="#!" onClick={(e) => hendlerReplyDel(e, item.UCBC_COMMENT_SEQ)} aria-label="댓글 삭제"><i className="fa fa-times" aria-hidden="true"></i> 삭제</a>&nbsp;&nbsp;
                                                                    </> : ""
                                                                }
                                                                <i className="fa fa-clock-o" aria-hidden="true"></i> {item.UCBC_REG_DT}
                                                            </span>
                                                        </div>
                                                        <p style={{ marginTop: "30px" }}>
                                                            {
                                                                item.UCBC_IMG_PATH !== "" ? <>
                                                                    <Paper sx={{ maxWidth: { md: "350px", xs: "100%" }, border: "1px solid #000000" }}
                                                                        elevation={0}
                                                                        component="img"
                                                                        className="img_add_file"
                                                                        src={item.UCBC_IMG_PATH}
                                                                        alt=""
                                                                        loading="lazy"
                                                                        onClick={(window as any).handleImageClick}
                                                                    />
                                                                </> : <></>
                                                            }
                                                            {/* 'DOMPurify.sanitize' 함수를 사용하면, <a>만 남고 <script>는 제거됨 - 터미널에서 'npm install dompurify' 입력해서 설치 필요 */}
                                                            <div dangerouslySetInnerHTML={{ __html: CommonUtil.autoLink(item.UCBC_CONTENT, { target: "_blank" }) }} />
                                                            <div style={{ marginTop: "20px" }}>
                                                                {
                                                                    item.UCBC_COMMENT_SEQ === answerTargetSeq
                                                                        ? <a id={"answer_btn_" + item.UCBC_COMMENT_SEQ} className="guest commment_reg" style={{ padding: "5px", textDecoration: "none", backgroundColor: "#ff762d" }} href="#none" onClick={(e) => hendlerAnswer(e, "")}>답글취소</a>
                                                                        : <a id={"answer_btn_" + item.UCBC_COMMENT_SEQ} className="guest commment_reg" style={{ padding: "5px", textDecoration: "none" }} href="#none" onClick={(e) => hendlerAnswer(e, item.UCBC_COMMENT_SEQ)}>답글등록</a>
                                                                }
                                                            </div>
                                                            <div id={"answer_ui_" + item.UCBC_COMMENT_SEQ}></div>
                                                        </p>
                                                    </div>
                                                </article>
                                                <article className="c_5241" id={"answer_result_" + item.UCBC_COMMENT_SEQ} style={{ display: item.UCBC_COMMENT_SEQ === answerTargetSeq ? "block" : "none" }}>
                                                    <ReplyReg comment_seq={item.UCBC_COMMENT_SEQ} />
                                                </article>
                                            </div>
                                        )
                                    }
                                    else {
                                        // 답글 일 경우

                                        return (
                                            <article className="c_5241" key={idx} id={"comment_root_" + item.UCBC_COMMENT_SEQ}>
                                                <i className="fa fa-hand-o-right fa-2x" aria-hidden="true" style={{ float: "left", marginTop: "15px" }}></i>
                                                <div className="cmt_contents" style={{ marginLeft: "30px", background: "#f0f0f0", padding: "15px", border: "0px" }}>
                                                    <div>
                                                        {
                                                            item.UCBC_ANONYMOUS_YN === "Y" ?
                                                                <span className="guest anonymous" style={{ float: "left" }}>익명</span>
                                                                :
                                                                <span className="guest" style={{ float: "left" }}>{item.UCBC_REG_NICKNAME}</span>
                                                        }
                                                        <span className="bo_vc_hdinfo" style={{ float: "right", textAlign: "right" }}>
                                                            {
                                                                item.UCBC_REG_MEM_UDID === MEM_UDID ? <>
                                                                    <a href="#!" onClick={(e) => hendlerReplyDel(e, item.UCBC_COMMENT_SEQ)} aria-label="댓글 삭제"><i className="fa fa-times" aria-hidden="true"></i> 삭제</a>&nbsp;&nbsp;
                                                                </> : ""
                                                            }
                                                            <i className="fa fa-clock-o" aria-hidden="true"></i> {item.UCBC_REG_DT}
                                                        </span>
                                                    </div>
                                                    <p style={{ marginTop: "30px" }}>
                                                        {
                                                            item.UCBC_IMG_PATH !== "" ? <>
                                                                <Paper sx={{ maxWidth: { md: "350px", xs: "100%" }, border: "1px solid #000000" }}
                                                                    elevation={0}
                                                                    component="img"
                                                                    className="img_add_file"
                                                                    src={item.UCBC_IMG_PATH}
                                                                    alt=""
                                                                    onClick={(window as any).handleImageClick}
                                                                />
                                                            </> : <></>
                                                        }
                                                        {/* 'DOMPurify.sanitize' 함수를 사용하면, <a>만 남고 <script>는 제거됨 - 터미널에서 'npm install dompurify' 입력해서 설치 필요 */}
                                                        <div dangerouslySetInnerHTML={{ __html: CommonUtil.autoLink(item.UCBC_CONTENT, { target: "_blank" }) }} />
                                                    </p>
                                                </div>
                                            </article>
                                        )
                                    }
                                })

                            }
                            <div style={{ width: "100%", height: "10px", float: "left" }}>&nbsp;</div>

                            <div id="div_Reply_More" style={Object.assign({ textAlign: "center", marginBottom: "30px" }, isMoreBtn ? {} : { display: "none" }) as React.CSSProperties}>
                                <a href="#!" onClick={handlerAddBtn} className="btn_b01 btn" aria-label="더보기"><i className="fa fa-plus" aria-hidden="true"></i> 더보기</a>
                            </div>
                        </>
                }
            </section>
        </>
    }
}

export default ReplyList;
